<script setup>
import { computed } from 'vue';

const props = defineProps({
  piecesClaimed: { type: Number, required: true },
  piecesTotal: { type: Number, required: true },
  // Gold variant for a completed offer — a distinct skin, not a fork.
  complete: { type: Boolean, default: false },
});

const fillWidth = computed(() => {
  if (!props.piecesTotal) return '0%';
  return `${Math.min(100, Math.round((props.piecesClaimed / props.piecesTotal) * 100))}%`;
});
</script>

<template>
  <div
    class="poola-progress"
    :class="{ 'poola-progress--complete': complete }"
    role="progressbar"
    :aria-valuenow="piecesClaimed"
    :aria-valuemin="0"
    :aria-valuemax="piecesTotal"
  >
    <div class="poola-progress__track">
      <div class="poola-progress__fill" :style="{ width: fillWidth }" />
    </div>
  </div>
</template>

<style scoped>
.poola-progress__track {
  height: 6px;
  border-radius: var(--poolit-radius-full);
  background: rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.poola-progress__fill {
  height: 100%;
  background: var(--poolit-primary-500, #8b5cf6);
  border-radius: var(--poolit-radius-full);
  transition: width 0.35s ease;
}

.poola-progress--complete .poola-progress__track {
  background: rgba(212, 175, 55, 0.18);
}

.poola-progress--complete .poola-progress__fill {
  background: linear-gradient(90deg, #d4af37, #f5d576);
}
</style>
